import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BarChartIcon from '@mui/icons-material/BarChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import ScienceIcon from '@mui/icons-material/Science';

export default function AnalysisHome() {
  const navigate = useNavigate();
  const { t } = useTranslation('analysis'); // 'analysis' namespaceを使用

  const titleSx = {
    fontWeight: 800,
    letterSpacing: "0.01em",
    color: "text.primary",
    textAlign: "center",
    mb: 1,
  };

  const subtitleSx = {
    textAlign: "center",
    whiteSpace: "pre-line",
    color: "text.secondary",
    maxWidth: 820,
    mx: "auto",
    mb: 4,
  };

  const analysisCards = [
    {
      title: t('estimationPage.title'),
      description: t('estimationPage.description'),
      link: '/analysis/total-species-estimation',
      icon: <ScienceIcon fontSize="large" />
    },
    {
      title: t('comparison.title'),
      description: t('comparison.description'),
      link: '/analysis/comparison-with-checklists',
      icon: <BarChartIcon fontSize="large" />
    },
    {
      title: t('cumulativeTrends.title'),
      description: t('cumulativeTrends.description'),
      link: '/analysis/cumulative-description-trends',
      icon: <TimelineIcon fontSize="large" />
    },
    {
      title: t('annualTrends.title'),
      description: t('annualTrends.description'),
      link: '/analysis/annual-description-trends',
      icon: <TimelineIcon fontSize="large" />
    },
  ];

  return (
    <Box p={4}>
      <Container maxWidth="lg">
        <Typography variant="h2" sx={titleSx}>
          {t('title')}
        </Typography>
        <Typography variant="body1" sx={subtitleSx}>
          {t('description')}
        </Typography>
        <Typography variant="body1" sx={{ ...subtitleSx, mb: 3 }}>
          {t('notes.header')}
        </Typography>
        <Box component="ul" sx={{ maxWidth: 820, mx: "auto", color: "text.secondary", pl: 3, mb: 4 }}>
          <li><Typography variant="body1">{t('notes.note1')}</Typography></li>
          <li><Typography variant="body1">{t('notes.note2')}</Typography></li>
        </Box>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          {analysisCards.map((card, index) => (
            <Grid item xs={12} md={6} key={index}>
              <CardActionArea component="div" onClick={() => navigate(card.link)} sx={{ height: '100%' }}>
                <Card sx={{ display: 'flex', alignItems: 'center', p: 2, height: '100%' }}>
                  <Box sx={{ p: 2, display: { xs: 'none', sm: 'block' } }}>
                    {card.icon}
                  </Box>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>{card.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{card.description}</Typography>
                  </CardContent>
                </Card>
              </CardActionArea>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
